import { useCallback, useMemo } from "react";

/**
 * Reads a legacy comma-joined-IDs localStorage key once and exposes a way to
 * clear it after its contents have been seeded into a resource's bookmark
 * cache. Callers resolve `legacyIds` into full resource objects themselves
 * (the resolution strategy differs per resource type) and pass the result as
 * `ResourceSelector`'s `initialRecents`, wiring `onInitialRecentsSeeded` to
 * `clearLegacyRecents`.
 */
export function useLegacyRecentsMigration(storageKey: string) {
  const legacyIds = useMemo(() => {
    const str = localStorage.getItem(storageKey);
    return str ? str.split(",") : [];
  }, [storageKey]);

  const clearLegacyRecents = useCallback(() => {
    localStorage.removeItem(storageKey);
  }, [storageKey]);

  return { legacyIds, clearLegacyRecents };
}
